import Cookies from "js-cookie";

export function trackConversion({ action, resourceId, resourceType }) {
    const response = fetch(route("analytics.conversion"), {
        method: "POST",
        headers: {
            "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            action,
            url: window.location.href,
            resourceId,
            resourceType,
        }),
    })
        .then((response) => response.json());
}
